<template>
  <section class="bonita__form">
    <h1>{{ $t('forms.sep.em.mainTitle') }}</h1>
    <h2>{{ $t('forms.sep.em.mainSbuTitle') }}</h2>

    <period-of-stay :valid.sync="periodOfStay.valid"
                    :dormitoryPeriodYear="$t('periodOfStay.items.dormitoryPeriod-year-april')"
                    :dormitoryPeriodAutumn="$t('periodOfStay.items.dormitoryPeriod-autumn-december')"
                    :dormitoryPeriodSpring="$t('periodOfStay.items.dormitoryPeriod-spring-january-april')"
                    :period.sync="periodOfStay.period"
    />

    <contact-details :valid.sync="contactDetails.valid"
                     :address.sync="contactDetails.address"
                     :birthday.sync="contactDetails.birthday"
                     :birthLocation.sync="contactDetails.birthLocation"
                     :city.sync="contactDetails.city"
                     :country.sync="contactDetails.country"
                     :firstName.sync="contactDetails.firstName"
                     :lastName.sync="contactDetails.lastName"
                     :mail.sync="contactDetails.mail"
                     :nationality.sync="contactDetails.nationality"
                     :sex.sync="contactDetails.sex"
                     :title-other.sync="contactDetails.titleOther"
                     :title-class-name.sync="contactDetails.titleClassName"
                     :title-class-date.sync="contactDetails.titleClassDate"
                     :zipCode.sync="contactDetails.zipCode"
    />

    <registration-erasmus :valid.sync="registration.valid"
                          :origin-entity.sync="registration.originEntity"
                          :registration-faculty.sync="registration.registrationFaculty"
                          :registration-persued-degree.sync="registration.registrationPersuedDegree"
                          :title-other.sync="registration.titleOther"
                          :exchange-program.sync="registration.exchangeProgram"
    />

    <sep-accomodation :mui.sync="accommodation.mui"
                      :mui-choice1.sync="accommodation.muiChoice1"
                      :mui-choice2.sync="accommodation.muiChoice2"
                      :mui-choice3.sync="accommodation.muiChoice3"
                      :choice-crous.sync="accommodation.choiceCrous"
    >
      <v-select :label="$t('accommodation.choiceNumber', { number: 1 })"
                v-model="accommodation.crousRoomChoices.choice1"
                :items="choice1"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 2 })"
                v-model="accommodation.crousRoomChoices.choice2"
                :items="choice2"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 3 })"
                v-model="accommodation.crousRoomChoices.choice3"
                :items="choice3"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 4 })"
                v-model="accommodation.crousRoomChoices.choice4"
                :items="choice4"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 5 })"
                v-model="accommodation.crousRoomChoices.choice5"
                :items="choice5"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 6 })"
                v-model="accommodation.crousRoomChoices.choice6"
                :items="choice6"
      />
      <v-select :label="$t('accommodation.choiceNumber', { number: 7 })"
                v-model="accommodation.crousRoomChoices.choice7"
                :items="choice7"
      />
    </sep-accomodation>

    <sep-more-informations :valid.sync="moreInformation.valid"
                           :arrival-date.sync="moreInformation.arrivalDate"
                           :information-message.sync="moreInformation.informationMessage"
    />

    <authorization :valid.sync="authorization.valid"
                   :content="$t('forms.sep.em.authorization.content')"
                   :mui.sync="accommodation.mui"
                   :mui-authorization.sync="authorization.muiAuthorizationChecker"
                   :legal-notice-dormitory="authorization.legalNoticeDormitory"
                   :legal-notice-crous="authorization.legalNoticeCROUS"
                   :crous="accommodation.choiceCrous"
    />

    <nota-bene :content="$t('forms.sep.em.notaBene.content')"/>

    <v-btn @click="onSubmit"
           color="blue-grey"
           :disabled="!valid"
    >{{ $t('forms.sep.iut.button') }}</v-btn>
  </section>
</template>

<script>
import sepSubmitMixin from '@/mixins/sepSubmitMixin'
import { SEPEMData } from '@/mixins/dataBaseMixin'

export default {
  name: 'SEPEM',

  mixins: [sepSubmitMixin],

  components: {
    NotaBene: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/NotaBene'),
    Authorization: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/Authorization'),
    SepMoreInformations: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/SepMoreInformations'),
    SepAccomodation: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/SepAccomodation'),
    RegistrationErasmus: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/RegistrationErasmus'),
    ContactDetails: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/ContactDetails'),
    PeriodOfStay: () => import(/* webpackChunkName: "sepEM" */ '@/components/Parts/PeriodOfStay'),
  },

  data () {
    return {
      subPopulation: 'em',
      periods:{
        year:'dormitoryPeriod-year-april',
        autumn:'dormitoryPeriod-autumn-december',
        spring:'dormitoryPeriod-spring-january-april'
      },
      periodOfStay: {
        valid: false,
        period: true,
      },
      contactDetails: {
        valid: false,
        address: '',
        birthday: '',
        birthLocation: '',
        city: '',
        country: '',
        firstName: '',
        lastName: '',
        mail: '',
        nationality: '',
        sex: '',
        titleOther: '',
        titleClassName: '',
        titleClassDate: '',
        zipCode: '',
      },
      registration: {
        valid: false,
        originEntity: '',
        registrationFaculty: 'EM Strasbourg',
        registrationPersuedDegree: '',
        titleOther: '',
        exchangeProgram: '',
      },
      accommodation: {
        mui: false,
        muiChoice1: '',
        muiChoice2: '',
        muiChoice3: '',
        choiceCrous: false,
        crousRoomChoices: {
          choice1: '',
          choice2: '',
          choice3: '',
          choice4: '',
          choice5: '',
          choice6: '',
          choice7: '',
        },
        crousRoomList: [
          {
            value: 'housingWeiss',
            text: this.$t('accommodation.crousRoomList.housingWeiss'),
          },
          {
            value: 'housingCattleyas',
            text: this.$t('accommodation.crousRoomList.housingCattleyas'),
          },
          // {
          //   value: 'housingAppell9',
          //   text: this.$t('accommodation.crousRoomList.housingAppell9'),
          // },
          {
            value: 'housingAppell10',
            text: this.$t('accommodation.crousRoomList.housingAppell10'),
          },
          {
            value: 'housingAgapanthes',
            text: this.$t('accommodation.crousRoomList.housingAgapanthes'),
          },
          // {
          //   value: 'housingSomme',
          //   text: this.$t('accommodation.crousRoomList.housingSomme'),
          // },
          {
            value: 'housingRobertsau',
            text: this.$t('accommodation.crousRoomList.housingRobertsau'),
          },
        ],
      },
      moreInformation: {
        valid: false,
        arrivalDate: null,
        informationMessage: '',
      },
      authorization: {
        valid: false,
        muiAuthorizationChecker: false,
        legalNoticeDormitory: false,
        legalNoticeCROUS: false,
      },
    }
  },

  computed: {
    choice1 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice6
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice2 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice6
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice3 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice6
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice4 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice6
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice5 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice6
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice6 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice7
      })
    },
    choice7 () {
      return this.accommodation.crousRoomList.filter(room => {
        return room.value !== this.accommodation.crousRoomChoices.choice1
          && room.value !== this.accommodation.crousRoomChoices.choice2
          && room.value !== this.accommodation.crousRoomChoices.choice3
          && room.value !== this.accommodation.crousRoomChoices.choice4
          && room.value !== this.accommodation.crousRoomChoices.choice5
          && room.value !== this.accommodation.crousRoomChoices.choice6
      })
    },
  },

  methods: {
    resetData() {
      Object.assign(this.$data, SEPEMData())
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style";
</style>
